import React from 'react';

/**
 * Skeleton Card Component
 * Displays a loading placeholder for card content
 *
 * @param {string} type - Card type variant ('service', 'achievement', 'feature')
 */
const SkeletonCard = ({ type = 'achievement' }) => {
  return (
    <div className="skeleton-card">
      {/* Icon skeleton */}
      <div className="skeleton skeleton-icon"></div>

      {/* Title skeleton */}
      <div className="skeleton skeleton-title"></div>

      {/* Description lines skeleton */}
      <div className="skeleton skeleton-text"></div>
      <div className="skeleton skeleton-text short"></div>

      {/* Conditional extra content based on card type */}
      {type === 'service' && (
        <>
          <div className="skeleton skeleton-text medium" style={{ marginTop: '20px' }}></div>
          <div className="skeleton skeleton-text short"></div>
          <div className="skeleton skeleton-text medium"></div>
        </>
      )}

      {type === 'feature' && (
        <div className="skeleton skeleton-button"></div>
      )}
    </div>
  );
};

export default SkeletonCard;
